import { useState } from 'react';

const StatusTooltip = ({ status, children }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  // Get tooltip message from environment variable
  const getTooltipMessage = (status) => {
    return process.env.NEXT_PUBLIC_STATUS_TOOLTIP_MESSAGE || ' ';
  };

  const tooltipMessage = getTooltipMessage(status);
  const shouldShowTooltip = status && ['coming soon', 'low stock', 'no stock'].includes(status.toLowerCase());

  if (!shouldShowTooltip) {
    return <>{children}</>;
  }

  return (
    <div className="position-relative d-inline-block">
      {children}
             <div
         className="position-absolute d-inline-flex align-items-center"
         style={{ 
           cursor: 'pointer',
           right: '0px',
           top: '0',
           height: '100%'
         }}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        onFocus={() => setShowTooltip(true)}
        onBlur={() => setShowTooltip(false)}
        tabIndex={0}
        role="button"
        aria-label={`More information about ${status}`}
      >
        <div
          className="rounded-circle d-flex align-items-center justify-content-center"
          style={{
            width: '16px',
            height: '16px',
            backgroundColor: '#dc3545',
            color: 'white',
            fontSize: '10px',
            fontWeight: 'bold',
            cursor: 'pointer'
          }}
        >
          i
        </div>
        
                          {showTooltip && tooltipMessage && (
           <div
             className="position-absolute bg-dark text-white p-2 rounded"
             style={{
               bottom: '25px',
               right: '0',
               zIndex: 1000,
               fontSize: '12px',
               whiteSpace: 'nowrap',
               boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
               lineHeight: '1.4'
             }}
           >
             {tooltipMessage}
            <div
              className="position-absolute"
              style={{
                top: '100%',
                right: '10px',
                width: 0,
                height: 0,
                borderLeft: '5px solid transparent',
                borderRight: '5px solid transparent',
                borderTop: '5px solid #343a40'
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default StatusTooltip;
